import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';
import { ISelectedFilters } from '../types';

export const listCandidatesStart = createAction(
  'LIST_CANDIDATES::START',
  withPayloadType<{ selectedFilters: ISelectedFilters; organizationId: string }>(),
);
